import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import messages from './Navigation.messages';
import IwocaLogo from './iwocaLogo';
import IwocaPayLogo from './iwocaPayLogo';
import styles from './Navigation.module.css';
import { PhoneSVG } from '../../svgComponents/phoneSVG/index';
import { SwitchIconSVG } from '../../svgComponents/switchIconSVG/index';
import { REQUEST_CHANGE_ROUTER } from '../../iwRouter/IwRouter.actions';
import {
    isIwocaPayCustomer as isIwocaPayCustomerSelector,
    isIwocaPaySeller
} from '../../api/iwocaPaySelector';
import { OPEN_MODAL } from '../../iwModals/Modals.actions';

import IwMedia from '../../iwMedia/IwMedia';
import MenuAction from './MenuAction';
import ProductDashboardLinks from './ProductDashboardLinks';
import { FLEXI_12_URL } from '../dashboard/Dashboard.sagas';
import classNames from 'classnames';
import { RootState } from '@iwProvider/configureStore';
import { Dispatch } from 'redux';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { tracking } from '@iwoca/frontend-tracking-library';

const mapStateToProps = (state: RootState) => ({
    isIwocaPaySeller: isIwocaPaySeller(state),
    hasIwocaPayLoan: isIwocaPayCustomerSelector(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToHome: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: FLEXI_12_URL }
        }),
    openHelpModal: () =>
        dispatch({
            type: OPEN_MODAL,
            id: 'HelpModal'
        })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const Navigation = ({
    isIwocaPaySeller,
    hasIwocaPayLoan,
    openHelpModal,
    goToHome
}: PropsFromRedux) => {
    return (
        <div className={styles.navigationWrapper}>
            <nav
                className={styles.navigationContainer}
                data-testid="navigation"
            >
                <div className={styles.actionsContainer}>
                    <div
                        className={styles.logoContainer}
                        data-testid="dashboard-navigation-logo"
                        onClick={goToHome}
                    >
                        {hasIwocaPayLoan ? (
                            <IwocaPayLogo className={styles.iwocaLogo} />
                        ) : (
                            <IwocaLogo className={styles.iwocaLogo} />
                        )}
                    </div>
                    <IwMedia from="medium">
                        <div
                            className={styles.productLinks}
                            data-testid="product-links-desktop"
                        >
                            <ProductDashboardLinks
                                activeClassName={styles.navLinkActive}
                            />
                        </div>
                    </IwMedia>
                </div>

                <div className={styles.actionsContainer}>
                    <IwMedia from="small">
                        {isIwocaPaySeller && (
                            <a
                                href={getIwocaPayDashboardLink()}
                                onClick={() => {
                                    tracking.ampli.switchedToIwocaPayDashboard();
                                }}
                                className={classNames(
                                    styles.rightAction,
                                    styles.iwocapayDashboardLink
                                )}
                            >
                                <FormattedMessage
                                    {...messages.iwocapaySeller}
                                />
                                <SwitchIconSVG className={styles.switchIcon} />
                            </a>
                        )}
                        <button
                            className={styles.rightAction}
                            onClick={openHelpModal}
                        >
                            <FormattedMessage {...messages.help} />
                            <PhoneSVG className={styles.helpLogo} />
                        </button>
                    </IwMedia>
                    <MenuAction />
                </div>
            </nav>
        </div>
    );
};

export function getIwocaPayDashboardLink() {
    const routerStateKey = getQueryParameter(getCurrentLocation(), 'state_key');
    const query = routerStateKey ? `?state_key=${routerStateKey}` : '';
    return '/pay/activation/' + query;
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
